{
  "unit": {
    "kwh": "kWh",
    "du": "度",
    "du_hint": "1 度 = 1 kWh"
  },
  "fmt": {
    "less_than": "不到 {{v}}",
    "approx": "约 {{v}}"
  },
  "cmp": {
    "flat": "持平",
    "more_pct": "多 {{pct}}%",
    "less_pct": "少 {{pct}}%",
    "more_abs": "多 {{v}}",
    "less_abs": "少 {{v}}",
    "why_prev_coverage": "上一期同期数据完整度 {{pct}}%，不到 90%，不比较",
    "why_meters_changed": "量测点跟上一期不同（新增或移除），不比较",
    "why_prev_small": "上一期不到 1 度，改写差多少",
    "why_unavailable": "读不到，不比较",
    "why_no_prev": "上一期没有数据，不比较",
    "why_btn": "为什么没有比较"
  },
  "q": {
    "measured": "实测",
    "estimated": "补估",
    "incomplete": "没有数据"
  },
  "chart": {
    "numbers": "看数字",
    "group": "{{title}}（左右键逐格看）",
    "legend_bar": "实测",
    "legend_est": "补估",
    "legend_miss": "没有数据（不是 0）",
    "legend_live": "进行中",
    "legend_zero": "实测 0",
    "col_time": "时间",
    "col_quality": "数据质量",
    "total": "合计",
    "prev_day": "前一天",
    "next_day": "下一天",
    "prev_cell": "前一格",
    "next_cell": "下一格",
    "say_day": "{{label}}，{{v}}，{{q}}",
    "say_live": "{{label}}，{{v}}，进行中（到 {{time}}）",
    "say_miss": "{{label}}，没有数据",
    "day_label": "{{m}} 月 {{d}} 日",
    "hour_label": "{{h}} 时",
    "month_label": "{{m}} 月",
    "tz_note": "以 {{tz}} 显示；每日合计依各$t(translation:leaf.cur)当地日期"
  },
  "meter": {
    "poe_powered": "{{station}} · 第 {{port}} 孔供电",
    "port": "{{station}} 第 {{port}} 孔",
    "port_of_home": "{{home}} {{station}} 第 {{port}} 孔",
    "unmatched": "没有对到设备"
  },
  "kind": {
    "plug": "插座",
    "poe": "PoE 供电",
    "meter": "电表"
  },
  "title": "用电",
  "subtitle": "会回报用电的设备花了多少电、大概多少钱",
  "tab": {
    "overview": "总览",
    "ranking": "用电排行",
    "report": "报表"
  },
  "settings_btn": "用电设置",
  "settings_pick": "选择要设置的$t(translation:leaf.cur)",
  "no_access_page": "只有能看用电的人能打开这页",
  "empty": "{{scope}}没有会回报用电的设备。会回报的有：{{brand}}插座、有 PoE 供电明细的 Kinio Station、经{{brand}}中枢连进来的 Matter 插座 / 电表。",
  "empty_all": "切到全部",
  "load_err": "读不到用电数据（{{reason}}）",
  "retry": "重试",
  "partial_err": "有些组织的用电数据读不到，下面只算读得到的",
  "mock_banner": "示意数据：用电 API 还没上这个环境，画面用假数据",
  "first_notice": "第一次打开用电页：用电数据只给能看用电的人看；量到的是插座、PoE 供电与电表，不是整个$t(translation:leaf.cur)的总用电。",
  "dismiss": "知道了",
  "period": {
    "month_to_date": "本月到今天",
    "last_month": "上个月",
    "today": "今天",
    "week": "本周到今天",
    "year": "今年到今天"
  },
  "need": {
    "title": "需要处理",
    "count": "{{n}} 项",
    "count_shown": "{{n}} 项 · 显示 {{shown}} 项",
    "show_all": "看全部 {{n}} 项",
    "plug_title": "{{home}} · {{name}}因过载已关闭",
    "plug_rated": "{{time}} 用电 {{w}}，超过插座上限 {{limit}} · 现在 0 W",
    "plug_user": "{{time}} 用电 {{w}}，超过设置的上限 {{limit}} · 现在 0 W",
    "poe_title_high": "{{home}} · {{name}} 的 PoE 供电超过异常门槛（{{pct}}%）",
    "poe_title_warn": "{{home}} · {{name}} 的 PoE 供电超过注意门槛（{{pct}}%）",
    "poe_detail": "已配置 {{alloc}} / {{rated}}（{{pct}}%）· 实际 {{used}}",
    "poe_more_cam": "再接新摄像头可能不供电",
    "poe_incident": "这个$t(translation:leaf.cur)开了 IT 监控，已开事故",
    "home_unavailable": "{{home}}读不到 {{h}} 小时（{{since}} 起）",
    "home_unavailable_d": "Station 与插座都离线；这段的用电没有计入",
    "gap_title": "{{n}} 个量测点读不到超过 {{h}} 小时",
    "gap_detail": "{{list}}；设备在线，但没有回报用电",
    "gap_item": "{{home}} {{n}} 个",
    "act_device": "看设备",
    "act_incident": "看事故",
    "act_poe": "看供电",
    "act_home": "看$t(translation:leaf.cur)",
    "act_which": "看是哪些"
  },
  "card": {
    "energy": "本月到今天用电",
    "energy_period": "{{period}}用电",
    "cmp_prev_month": "比上月同期",
    "cmp_prev": "比上期同期",
    "cmp_basis": "同样 {{homes}} 个$t(translation:leaf.cur)、{{meters}} 个量测点比较",
    "cmp_excluded": "{{list}}未计入比较",
    "cmp_ex_new": "{{home}}（新增量测点）",
    "cmp_ex_cov": "{{home}}（上个月同期数据不到 90%）",
    "cmp_ex_other": "{{home}}",
    "cmp_none": "不比较：{{why}}",
    "incomplete": "{{meters}} 个量测点数据不完整（共缺 {{hours}} 小时）",
    "forecast": "整月预估 {{v}}",
    "cost": "估算电费",
    "cost_homes": "{{n}} 个$t(translation:leaf.cur)",
    "cost_more": "{{n}} 种币种",
    "cost_note": "不同币种分开列、不换汇 · 不含基本电费",
    "cost_disclaimer": "估算值，不能作为收费或分摊依据",
    "no_tariff": "{{n}} 个$t(translation:leaf.cur)没设电价，未计入",
    "no_tariff_any": "还没设置电价",
    "set_tariff": "设置电价",
    "carbon": "碳排放",
    "carbon_note": "{{region}}{{provisional}}{{year}} 年{{source}}系数",
    "carbon_provisional": "暂用 ",
    "carbon_co2only": "（只有 CO2）",
    "carbon_ref": "仅供运营参考",
    "poe_note": "PoE 供电量不含 Station 本体与电源转换损耗。",
    "visible_only": "只计入你能看用电的 {{visible}} 个$t(translation:leaf.cur)（范围内共 {{total}} 个）",
    "unavailable_homes": "{{n}} 个$t(translation:leaf.cur)读不到，未计入"
  },
  "trend": {
    "title_day": "趋势 · 今天每小时用电",
    "title_month": "趋势 · 每日用电",
    "title_year": "趋势 · 每月用电",
    "day": "日",
    "month": "月",
    "year": "年",
    "granularity": "趋势的期间",
    "by_kind": "依种类",
    "total_only": "合计",
    "compare": "比较$t(translation:leaf.cur)…",
    "compare_n": "比较$t(translation:leaf.cur)（{{n}}）",
    "compare_title": "选最多 5 个$t(translation:leaf.cur)比较",
    "compare_done": "比较",
    "compare_clear": "取消比较",
    "compare_max": "最多 5 个",
    "daily_total": "每日合计",
    "today_live": "今天（进行中，到 {{time}}）"
  },
  "table": {
    "by_home": "依$t(translation:leaf.cur)",
    "by_org": "依组织",
    "sort_hint": "依「比上月」由多到少；不符合比较条件的写「—」，点「—」看原因，排在最后。",
    "sort_cmp": "比上月",
    "sort_energy": "用电量",
    "col_home": "$t(translation:leaf.cur)",
    "col_org": "组织",
    "col_kwh": "本月 kWh",
    "col_period_kwh": "本期 kWh",
    "col_cmp": "比上月",
    "col_cmp_period": "比上期",
    "col_daily": "每日平均",
    "col_cost": "估算电费",
    "col_meters": "量测点",
    "col_unavail": "读不到（量测点）",
    "col_carbon": "碳排放",
    "no_tariff": "未设置电价",
    "more": "另有 {{n}} 个$t(translation:leaf.cur)",
    "show_all": "看全部 {{n}} 个",
    "cross_currency": "跨币种不排序",
    "homes_count": "{{n}} 个$t(translation:leaf.cur)",
    "m2": "比上月 {{cmp}} · {{cost}} · 读不到 {{n}} 个量测点",
    "m2_ok": "比上月 {{cmp}} · {{cost}}",
    "unavailable": "读不到"
  },
  "ups": {
    "title": "不间断电源",
    "line_ok": "{{n}} 台 UPS · 都用市电",
    "line_battery": "{{n}} 台 UPS · {{b}} 台用电池中 · 最短可撑 {{rt}}",
    "line_battery_unk": "{{n}} 台 UPS · {{b}} 台用电池中 · 剩余时间读不到",
    "unreadable": "{{n}} 台读不到",
    "minutes": "{{n}} 分钟",
    "note": "UPS 的输出用电量的是另一组设备，不加进上面的总数。",
    "go": "到 IT 监控看",
    "load_err": "读不到 UPS 状态"
  },
  "rank": {
    "by_device": "依设备",
    "by_port": "依 PoE 孔",
    "group": "排行方式",
    "kinds": "种类",
    "all_homes": "全部$t(translation:leaf.cur)",
    "search": "找设备或$t(translation:leaf.cur)",
    "export": "导出 CSV",
    "col_name": "名称",
    "col_kind": "种类",
    "col_kwh": "本期 kWh",
    "col_avg": "平均功率",
    "col_max": "最高功率",
    "col_cost": "估算电费",
    "col_cmp": "比上期",
    "col_mode": "功耗模式",
    "col_pick": "选取",
    "pick_all": "全选这页可以设置的摄像头",
    "pick_row": "选取 {{name}}",
    "no_control": "你没有这台的控制权限，不能设置功耗模式",
    "mode_changed": "{{date}} 改「{{mode}}」",
    "mode_effect": "{{date}} 改「{{mode}}」· 前后各 {{days}} 天{{cmp}}",
    "footer": "第 {{from}}–{{to}} 名，共 {{total}} 个量测点",
    "footer_filtered": "筛选「{{f}}」· 第 {{from}}–{{to}} 名，共 {{total}} 个量测点",
    "next": "下一页",
    "prev": "上一页",
    "empty": "这段期间没有用电数据",
    "filters": "排序与筛选",
    "close": "关闭",
    "show": "显示 {{n}} 个",
    "sort": "排序",
    "sort_kwh": "用电量多到少",
    "sort_avg": "平均功率高到低",
    "sort_max": "最高功率高到低",
    "sort_cmp": "比上期多到少",
    "by_station": "{{home}} · {{station}}",
    "csv_name": "用电排行"
  },
  "pm": {
    "0": "画质优先",
    "1": "平衡",
    "2": "省电优先",
    "picked": "已选 {{n}} 支摄像头",
    "why": "省的是电费；PoE 已配置依等级预留，改功耗模式不会降低已配置。每台各自检查权限。",
    "clear": "取消选取",
    "set": "设置功耗模式…",
    "dlg_title": "把 {{n}} 支摄像头改成…",
    "dlg_saving": "省的是电费：依最近 7 天推估，每月约少 {{v}}",
    "dlg_alloc": "改功耗模式不会降低 PoE 已配置；要腾预算请改用较低 PoE 等级的摄像头或分到别台 Station。",
    "dlg_affects": "会影响：{{names}}",
    "dlg_quality": "「省电优先」夜间补光与画质可能降低。",
    "dlg_ok": "套用到 {{n}} 支",
    "dlg_cancel": "取消",
    "result_title": "功耗模式结果",
    "result_summary": "{{applied}} 支已套用、{{pending}} 支等待设备套用",
    "result_failed": "{{n}} 支没有套用",
    "st_applied": "✓ 已套用",
    "st_pending": "⟳ 等待设备套用",
    "st_failed": "✕ 设备没有套用",
    "st_forbidden": "✕ 没有控制权限",
    "deadline": "最晚 {{time}} 知道结果；到时还没套用会改成「设备没有套用」",
    "retry": "重试",
    "done": "完成",
    "err": "设置失败：{{msg}}"
  },
  "report": {
    "month": "月份",
    "month_opt": "{{y}} 年 {{m}} 月",
    "opt_provisional": "（暂定）",
    "opt_final": "（已定案）",
    "provisional": "暂定：设备补报的数据可能让数字再变动，{{date}}定案",
    "final": "已定案",
    "date_md": "{{m}} 月 {{d}} 日",
    "scope_total": "范围合计",
    "gaps": "缺 {{hours}} 小时（{{meters}} 个量测点）",
    "no_gaps": "没有缺口",
    "summary_by": "依$t(translation:leaf.cur)摘要",
    "only_gaps": "只看有缺口的（{{n}}）",
    "has_gap": "! 有缺口",
    "expand": "展开 {{home}} 的量测点",
    "top": "前 10 名",
    "rounding": "各列四舍五入显示，合计依未四舍五入的值计算（CSV 保留两位小数）",
    "csv_homes": "下载 CSV（逐$t(translation:leaf.cur) × 逐日）",
    "csv_meters": "下载 CSV（逐量测点 × 逐月）",
    "csv_prefix": "用电",
    "provisional_tag": "暂定",
    "carbon_basis": "{{gas}} · {{year}} 年系数",
    "pdf_later": "PDF 与每月寄送之后提供"
  },
  "csv": {
    "disclaimer": "估算值，不能作为收费或分摊依据",
    "date": "日期",
    "month": "月份",
    "home": "$t(translation:leaf.cur)",
    "org": "组织",
    "meter_name": "量测点",
    "meter_kind": "种类",
    "kwh": "用电（kWh）",
    "avg_w": "平均功率（W）",
    "max_w": "最高功率（W）",
    "cost": "估算电费（{{cur}}）",
    "currency": "币种",
    "cost_amount": "估算电费",
    "quality": "数据质量（实测 / 补估 / 没有数据）",
    "missing_h": "缺的小时",
    "carbon": "碳排放（kg）",
    "carbon_basis": "碳排口径"
  },
  "org": {
    "card_title": "电价与碳排",
    "card_hint": "{{n}} 个电价方案 · 套用到$t(translation:leaf.cur)后估算电费",
    "manage": "管理电价",
    "title": "电价",
    "crumb": "组织设置",
    "hint": "电价方案套用到$t(translation:leaf.cur)后，用电页才算得出估算电费。建议：同电价的$t(translation:leaf.cur)用〔套用到$t(translation:leaf.cur)…〕并到同一个方案、之后只维护一个；要保留名称与版本记录才用〔改用新版…〕。",
    "no_admin": "只有组织所有者或组织管理员能管理电价",
    "col_name": "方案",
    "col_kind": "类型",
    "col_currency": "币种",
    "col_applied": "套用到",
    "col_version": "目前版本",
    "applied_n": "{{n}} 个$t(translation:leaf.cur)",
    "version_from": "v{{v}} · {{date}} 起",
    "kind_flat": "单一单价",
    "kind_tiered": "累进级距",
    "kind_tou": "时间电价",
    "add": "新增方案",
    "apply": "套用到$t(translation:leaf.cur)…",
    "new_version": "改用新版…",
    "delete": "删除",
    "delete_confirm": "删除「{{name}}」？",
    "in_use": "还有 {{n}} 个$t(translation:leaf.cur)在用这个方案，先把它们改用别的方案再删",
    "empty": "还没有电价方案",
    "carbon_title": "碳排",
    "show_carbon": "在用电总览显示碳排卡",
    "carbon_category": "排碳系数类别",
    "cat_grid": "电网平均（依地区与年度）",
    "saved": "✓ 已保存",
    "recalc": "重算中，约 1 分钟",
    "no_rates": "看不到单价（只有$t(translation:leaf.cur)所有者 / 管理员与组织管理员看得到）"
  },
  "ed": {
    "title": "新增电价方案",
    "from_template": "从模板",
    "custom": "自定义",
    "template": "模板",
    "template_note": "模板的单价照官方公告；写进前会对原文，画面上的数字只是起点，可以改。",
    "name": "方案名称",
    "kind": "类型",
    "currency": "币种",
    "effective": "生效日",
    "effective_hint": "默认这个月 1 日；最多追溯 30 天；选到已定案的月份不会重算",
    "flat_price": "每度单价",
    "tier": "第 {{n}} 级",
    "tier_upto": "每月 {{v}} 度以下",
    "tier_rest": "以上",
    "tou_period": "{{name}}（{{days}} {{from}}–{{to}} 时）",
    "days_weekday": "周一至周五",
    "days_weekend": "周末与假日",
    "days_all": "每天",
    "per_kwh": "{{cur}} / 度",
    "save": "建立方案",
    "cancel": "取消",
    "err_name": "方案名称必填",
    "err_price": "单价要是 0 以上的数字",
    "version_title": "「{{name}}」改用新版",
    "version_save": "加新版本"
  },
  "apply": {
    "title": "把「{{name}}」套用到$t(translation:leaf.cur)",
    "filter_old": "目前用旧方案（{{n}}）",
    "filter_none": "没设电价（{{n}}）",
    "filter_all": "全部（{{n}}）",
    "shown": "显示 {{n}} 个$t(translation:leaf.cur)",
    "hidden": "另 {{n}} 个不符合",
    "clear_filter": "清除筛选",
    "current": "目前：{{name}}",
    "current_none": "目前：没设电价",
    "already": "已经是这个方案",
    "currency_diff": "币种不同（{{cur}}），不能套用",
    "pick_all": "全选「{{group}}」",
    "next": "套用到 {{n}} 个$t(translation:leaf.cur)…",
    "confirm_title": "把「{{name}}」套用到 {{n}} 个$t(translation:leaf.cur)",
    "confirm_body": "这 {{n}} 个$t(translation:leaf.cur) {{date}}起的估算电费会用新方案重算；已下载的报表不会跟着改。",
    "confirm_old": "其中 {{n}} 个原本用「{{old}}」。",
    "final_warn": "{{month}} 已定案，不会重算",
    "ok": "套用",
    "done": "已套用到 {{n}} 个$t(translation:leaf.cur)",
    "done_one": "已套用",
    "undo": "复原",
    "none_picked": "先勾要套用的$t(translation:leaf.cur)"
  },
  "leaf": {
    "title": "用电设置",
    "crumb_sites": "组织与场所",
    "locked": "只有所有者或管理员能修改",
    "tariff": "电价",
    "tariff_org": "沿用：{{name}}",
    "tariff_home": "{{name}}（这个$t(translation:leaf.cur)自己设的）",
    "tariff_none": "还没设置电价",
    "tariff_pick": "改选",
    "tariff_none_opt": "不设电价（电费不计入）",
    "tariff_custom": "自定义…（到组织设置 › 电价）",
    "alerts": "用电提醒",
    "poe": "PoE 供电",
    "poe_desc": "超过 Station 额定的这个比例时提醒",
    "poe_warn": "注意",
    "poe_high": "异常",
    "pct": "%",
    "gap": "读不到数据",
    "gap_desc": "设备在线、超过这么多小时没有回报用电就提醒",
    "hours": "小时",
    "kmgr_on": "这个$t(translation:leaf.cur)开了 IT 监控：超过门槛会开事故、照轮值表通知",
    "kmgr_off": "超过门槛会通知$t(translation:leaf.cur)的所有者与管理员（只进收件箱）",
    "managed": "由模板「{{name}}」管理",
    "unmanage": "解除模板管理",
    "unmanage_confirm": "解除后这里的门槛可以自己改，模板之后的变更不再套到这个$t(translation:leaf.cur)。",
    "saved": "✓ 已保存",
    "saving": "保存中…",
    "err_range": "要是 {{min}}–{{max}} 的整数",
    "err_order": "注意门槛不能高于异常门槛",
    "pick_title": "选择$t(translation:leaf.cur)",
    "not_found": "找不到这个$t(translation:leaf.cur)，或你没有它的权限",
    "to_overview": "看这个$t(translation:leaf.cur)的用电"
  },
  "dev": {
    "title": "用电",
    "now": "现在",
    "today": "今天",
    "month": "本月到今天",
    "cost": "估算电费",
    "via_poe": "由 PoE 供电量测（{{station}} 第 {{port}} 孔）",
    "range_day": "日",
    "range_week": "周",
    "range_month": "月",
    "chart_day": "最近 24 小时每小时用电",
    "chart_week": "最近 7 天每日用电",
    "chart_month": "最近 30 天每日用电",
    "export": "导出 CSV",
    "no_data": "还没有用电数据",
    "load_err": "用电数据读不到",
    "mode_mark": "{{date}} 改「{{mode}}」"
  },
  "stn": {
    "budget": "PoE 供电：已配置 {{alloc}} / {{rated}} · 实际 {{used}}",
    "budget_norated": "PoE 供电：目前供电 {{used}}",
    "alloc_note": "已配置比现在实际多 {{diff}}：PoE 依等级预留，改摄像头的功耗模式只省电费，不会降低已配置。",
    "col_today": "今天",
    "col_24h": "24 小时",
    "today": "今天 {{v}}",
    "spark": "第 {{port}} 孔最近 24 小时供电",
    "expand": "看第 {{port}} 孔 7 天曲线",
    "collapse": "收起",
    "week_title": "第 {{port}} 孔 · 最近 7 天每小时供电",
    "no_detail": "这台 Station 没有回报 PoE 供电明细",
    "load_err": "供电数据读不到",
    "unknown": "不知道",
    "budget_noalloc": "PoE 供电：额定 {{rated}} · 实际 {{used}}",
    "col_energy": "用电"
  },
  "syn": {
    "energy": "用电,电费,电价,功率,kWh,度,碳排,PoE,耗电,省电",
    "org_tariffs": "电价,电费,费率,碳排系数",
    "leaf_settings": "用电设置,用电提醒,PoE 门槛,电价",
    "ups": "UPS,不间断电源,停电,电池供电,PoE"
  },
  "search": {
    "leaf_settings": "$t(translation:leaf.cur)的用电设置（先选$t(translation:leaf.cur)）",
    "ups": "网络与应用 · 不间断电源（UPS）"
  },
  "err": {
    "ENERGY_RANGE_TOO_LARGE": "期间太长，请缩短后再试",
    "ENERGY_TARIFF_INVALID": "电价方案不正确：{{reason}}",
    "ENERGY_TARIFF_IN_USE": "还有$t(translation:leaf.cur)在用这个方案",
    "FORBIDDEN": "你没有权限",
    "VERSION_CONFLICT": "别人刚改过，刷新后再改",
    "NOT_FOUND": "用电 API 还没有这个数据",
    "other": "发生错误（{{code}}）",
    "copy": "复制给客服",
    "details": "详细"
  },
  "loading": "读取中…"
}
